import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ddb3a3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-3xs-b score-info-title" }, "기념품 순위", -1))
const _hoisted_2 = { class: "row score-info-container" }
const _hoisted_3 = { class: "text-center text-bold q-ma-none" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TodaysSouvenirScoreInfo',
  setup(__props) {

function getSouvenirSrc(souvenirNumber: number) {
  return require(`src/assets/training/todaysSouvenir/svg/souvenir${
    souvenirNumber - 1
  }.svg`) as string;
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (number) => {
        return _createElementVNode("div", {
          key: `souvenir-${number}`,
          class: "col-3 souvenir"
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(number), 1),
          _createVNode(_component_q_img, {
            src: getSouvenirSrc(number)
          }, null, 8, ["src"])
        ])
      }), 64))
    ])
  ], 64))
}
}

})